import { __assign, __extends, __rest } from "tslib";
import React, { PureComponent } from "react";
import { Keyboard, Modal, Platform, Text, TextInput, TouchableOpacity, View } from "react-native";
import isEqual from "lodash.isequal";
import { Picker } from 'react-native-web';
import PropTypes from "prop-types";
import styles from "../PnmacSelect.styles.js";
import { textStyle } from "../../v2/theme";
var PnmacSelect = /** @class */function (_super) {
  __extends(PnmacSelect, _super);
  function PnmacSelect(props) {
    var _this = _super.call(this, props) || this;
    var items = PnmacSelect.handlePlaceholder({
      placeholder: props.placeholder
    }).concat(props.items);
    var selectedItem = PnmacSelect.getSelectedItem({
      items: items,
      key: props.itemKey,
      value: props.value
    }).selectedItem;
    _this.state = {
      items: items,
      selectedItem: selectedItem,
      showPicker: false,
      animationType: undefined,
      orientation: "portrait",
      doneDepressed: false
    };
    _this.onUpArrow = _this.onUpArrow.bind(_this);
    _this.onDownArrow = _this.onDownArrow.bind(_this);
    _this.onValueChange = _this.onValueChange.bind(_this);
    _this.onOrientationChange = _this.onOrientationChange.bind(_this);
    _this.setInputRef = _this.setInputRef.bind(_this);
    _this.togglePicker = _this.togglePicker.bind(_this);
    _this.renderInputAccessoryView = _this.renderInputAccessoryView.bind(_this);
    return _this;
  }
  PnmacSelect.handlePlaceholder = function (_a) {
    var placeholder = _a.placeholder;
    if (isEqual(placeholder, {})) {
      return [];
    }
    return [placeholder];
  };
  PnmacSelect.getSelectedItem = function (_a) {
    var items = _a.items,
      key = _a.key,
      value = _a.value;
    var idx = items.findIndex(function (item) {
      if (item.key && key) {
        return isEqual(item.key, key);
      }
      return isEqual(item.value, value);
    });
    if (idx === -1) {
      idx = 0;
    }
    return {
      selectedItem: items[idx] || {},
      idx: idx
    };
  };
  PnmacSelect.getDerivedStateFromProps = function (nextProps, prevState) {
    // update items if items or placeholder prop changes
    var items = PnmacSelect.handlePlaceholder({
      placeholder: nextProps.placeholder
    }).concat(nextProps.items);
    var itemsChanged = !isEqual(prevState.items, items);
    // update selectedItem if value prop is defined and differs from currently selected item
    var _a = PnmacSelect.getSelectedItem({
        items: items,
        key: nextProps.itemKey,
        value: nextProps.value
      }),
      selectedItem = _a.selectedItem,
      idx = _a.idx;
    var selectedItemChanged = !isEqual(nextProps.value, undefined) && !isEqual(prevState.selectedItem, selectedItem);
    if (itemsChanged || selectedItemChanged) {
      if (selectedItemChanged) {
        nextProps.onValueChange(selectedItem.value, idx);
      }
      return __assign(__assign({}, itemsChanged ? {
        items: items
      } : {}), selectedItemChanged ? {
        selectedItem: selectedItem
      } : {});
    }
    return null;
  };
  PnmacSelect.prototype.onUpArrow = function () {
    var onUpArrow = this.props.onUpArrow;
    this.togglePicker(false, onUpArrow);
  };
  PnmacSelect.prototype.onDownArrow = function () {
    var onDownArrow = this.props.onDownArrow;
    this.togglePicker(false, onDownArrow);
  };
  PnmacSelect.prototype.onValueChange = function (value, index) {
    var onValueChange = this.props.onValueChange;
    onValueChange(value, index);
    this.setState(function (prevState) {
      return {
        selectedItem: prevState.items[index]
      };
    });
  };
  PnmacSelect.prototype.onOrientationChange = function (_a) {
    var nativeEvent = _a.nativeEvent;
    this.setState({
      orientation: nativeEvent.orientation
    });
  };
  PnmacSelect.prototype.setInputRef = function (ref) {
    this.inputRef = ref;
  };
  PnmacSelect.prototype.getPlaceholderStyle = function () {
    var _a = this.props,
      placeholder = _a.placeholder,
      style = _a.style;
    var selectedItem = this.state.selectedItem;
    if (!isEqual(placeholder, {}) && selectedItem.label === placeholder.label) {
      return __assign(__assign({}, styles.placeholder), style.placeholder);
    }
    return {};
  };
  PnmacSelect.prototype.triggerOpenCloseCallbacks = function () {
    var _a = this.props,
      onOpen = _a.onOpen,
      onClose = _a.onClose;
    var showPicker = this.state.showPicker;
    if (!showPicker && onOpen) {
      onOpen();
    }
    if (showPicker && onClose) {
      onClose();
    }
  };
  PnmacSelect.prototype.togglePicker = function (animate, postToggleCallback) {
    if (animate === void 0) {
      animate = false;
    }
    var _a = this.props,
      modalProps = _a.modalProps,
      disabled = _a.disabled;
    var showPicker = this.state.showPicker;
    if (disabled) {
      return;
    }
    if (!showPicker) {
      Keyboard.dismiss();
    }
    var animationType = modalProps && modalProps.animationType ? modalProps.animationType : "slide";
    this.triggerOpenCloseCallbacks();
    this.setState(function (prevState) {
      return {
        animationType: animate ? animationType : undefined,
        showPicker: !prevState.showPicker
      };
    }, function () {
      if (postToggleCallback) {
        postToggleCallback();
      }
    });
  };
  PnmacSelect.prototype.renderPickerItems = function () {
    var items = this.state.items;
    return items.map(function (item) {
      return /*#__PURE__*/React.createElement(Picker.Item, {
        label: item.label,
        value: item.value,
        key: item.key || item.label,
        color: '#1B1B1B'
      });
    });
  };
  PnmacSelect.prototype.renderInputAccessoryView = function () {
    var _this = this;
    var _a = this.props,
      InputAccessoryView = _a.InputAccessoryView,
      doneText = _a.doneText,
      onUpArrow = _a.onUpArrow,
      onDownArrow = _a.onDownArrow,
      onDonePress = _a.onDonePress,
      style = _a.style,
      touchableDoneProps = _a.touchableDoneProps;
    var doneDepressed = this.state.doneDepressed;
    if (InputAccessoryView) {
      return /*#__PURE__*/React.createElement(InputAccessoryView, {
        testID: "custom_input_accessory_view"
      });
    }
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.modalViewMiddle, style.modalViewMiddle],
      testID: "input_accessory_view"
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles.chevronContainer, style.chevronContainer]
    }, /*#__PURE__*/React.createElement(TouchableOpacity, {
      activeOpacity: onUpArrow ? 0.5 : 1,
      onPress: onUpArrow ? this.onUpArrow : null
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles.chevron, style.chevron, styles.chevronUp, style.chevronUp, onUpArrow ? [styles.chevronActive, style.chevronActive] : {}]
    })), /*#__PURE__*/React.createElement(TouchableOpacity, {
      activeOpacity: onDownArrow ? 0.5 : 1,
      onPress: onDownArrow ? this.onDownArrow : null
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles.chevron, style.chevron, styles.chevronDown, style.chevronDown, onDownArrow ? [styles.chevronActive, style.chevronActive] : {}]
    }))), /*#__PURE__*/React.createElement(TouchableOpacity, __assign({
      testID: "done_button",
      onPress: function () {
        _this.togglePicker(true, onDonePress);
      },
      onPressIn: function () {
        _this.setState({
          doneDepressed: true
        });
      },
      onPressOut: function () {
        _this.setState({
          doneDepressed: false
        });
      },
      hitSlop: {
        top: 4,
        right: 4,
        bottom: 4,
        left: 4
      }
    }, touchableDoneProps), /*#__PURE__*/React.createElement(View, {
      testID: "needed_for_touchable"
    }, /*#__PURE__*/React.createElement(Text, {
      testID: "done_text",
      allowFontScaling: false,
      style: [styles.done, style.done, doneDepressed ? [styles.doneDepressed, style.doneDepressed] : {}]
    }, doneText))));
  };
  PnmacSelect.prototype.renderIcon = function () {
    var _a = this.props,
      style = _a.style,
      Icon = _a.Icon;
    if (!Icon) {
      return null;
    }
    return /*#__PURE__*/React.createElement(View, {
      testID: "icon_container",
      style: [styles.iconContainer, style.iconContainer]
    }, /*#__PURE__*/React.createElement(Icon, {
      testID: "icon"
    }));
  };
  PnmacSelect.prototype.renderTextInputOrChildren = function () {
    var _a = this.props,
      children = _a.children,
      style = _a.style,
      textInputProps = _a.textInputProps;
    var selectedItem = this.state.selectedItem;
    var containerStyle = Platform.OS === "ios" ? style.inputIOSContainer : style.inputAndroidContainer;
    if (children) {
      return /*#__PURE__*/React.createElement(View, {
        pointerEvents: "box-only",
        style: containerStyle
      }, children);
    }
    return /*#__PURE__*/React.createElement(View, {
      pointerEvents: "box-only",
      style: containerStyle
    }, /*#__PURE__*/React.createElement(TextInput, {
      testID: "text_input",
      style: [Platform.OS === "ios" ? style.inputIOS : style.inputAndroid, this.getPlaceholderStyle(), textStyle.formBody],
      value: selectedItem.displayValue ? selectedItem.value : selectedItem.label,
      ref: this.setInputRef,
      editable: false
    }), this.renderIcon());
  };
  PnmacSelect.prototype.renderIOS = function () {
    var _this = this;
    var _a = this.props,
      style = _a.style,
      modalProps = _a.modalProps,
      pickerProps = _a.pickerProps,
      touchableWrapperProps = _a.touchableWrapperProps;
    var _b = this.state,
      animationType = _b.animationType,
      orientation = _b.orientation,
      selectedItem = _b.selectedItem,
      showPicker = _b.showPicker;
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.viewContainer, style.viewContainer],
      testID: "renderAndroidNativePickerStyle"
    }, /*#__PURE__*/React.createElement(TouchableOpacity, __assign({
      testID: "ios_touchable_wrapper",
      onPress: function () {
        _this.togglePicker(true);
      },
      activeOpacity: 1
    }, touchableWrapperProps), this.renderTextInputOrChildren()), /*#__PURE__*/React.createElement(Modal, __assign({
      testID: "ios_modal",
      visible: showPicker,
      transparent: true,
      animationType: animationType,
      supportedOrientations: ["portrait", "landscape"],
      onOrientationChange: this.onOrientationChange
    }, modalProps), /*#__PURE__*/React.createElement(TouchableOpacity, {
      style: [styles.modalViewTop, style.modalViewTop],
      testID: "ios_modal_top",
      onPress: function () {
        _this.togglePicker(true);
      }
    }), this.renderInputAccessoryView(), /*#__PURE__*/React.createElement(View, {
      style: [styles.modalViewBottom, {
        height: orientation === "portrait" ? 215 : 162
      }, style.modalViewBottom]
    }, /*#__PURE__*/React.createElement(Picker, __assign({
      testID: "ios_picker",
      onValueChange: this.onValueChange,
      selectedValue: selectedItem.value
    }, pickerProps), this.renderPickerItems()))));
  };
  PnmacSelect.prototype.renderAndroidHeadless = function () {
    var _a = this.props,
      disabled = _a.disabled,
      Icon = _a.Icon,
      style = _a.style,
      pickerProps = _a.pickerProps,
      onOpen = _a.onOpen,
      touchableWrapperProps = _a.touchableWrapperProps,
      rest = __rest(_a, ["disabled", "Icon", "style", "pickerProps", "onOpen", "touchableWrapperProps"]);
    var selectedItem = this.state.selectedItem;
    return /*#__PURE__*/React.createElement(TouchableOpacity, __assign({
      testID: "renderAndroidNativePickerStyle",
      onPress: onOpen,
      activeOpacity: 1
    }, touchableWrapperProps, {
      nativeID: rest.idTag1
    }), /*#__PURE__*/React.createElement(View, {
      style: style.headlessAndroidContainer,
      nativeID: rest.idTag2
    }, this.renderTextInputOrChildren(), /*#__PURE__*/React.createElement(Picker, __assign({
      style: [Icon ? {
        backgroundColor: "transparent"
      } : {}, styles.headlessAndroidPicker, style.headlessAndroidPicker],
      testID: "renderAndroidNativePickerStyle",
      enabled: !disabled,
      onValueChange: this.onValueChange,
      selectedValue: selectedItem.value
    }, pickerProps, {
      nativeID: rest.idTag3
    }), this.renderPickerItems())));
  };
  PnmacSelect.prototype.renderAndroidNativePickerStyle = function () {
    var _a = this.props,
      disabled = _a.disabled,
      Icon = _a.Icon,
      style = _a.style,
      pickerProps = _a.pickerProps,
      rest = __rest(_a, ["disabled", "Icon", "style", "pickerProps"]);
    var selectedItem = this.state.selectedItem;
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.viewContainer, style.viewContainer],
      testID: "renderAndroidNativePickerStyle",
      nativeID: rest.idTag1
    }, /*#__PURE__*/React.createElement(Picker, __assign({
      style: [Icon ? {
        backgroundColor: "transparent"
      } : {}, style.inputAndroid, this.getPlaceholderStyle(), styles.androidContainer, textStyle.formBody, {
        width: "100%"
      }, style.pickerStyle],
      testID: "android_picker",
      accessibilityLabel: rest.accessibilityLabel,
      enabled: !disabled,
      onValueChange: this.onValueChange,
      selectedValue: selectedItem.value
    }, pickerProps, {
      nativeID: rest.idTag2
    }), this.renderPickerItems()), this.renderIcon());
  };
  PnmacSelect.prototype.render = function () {
    var _a = this.props,
      children = _a.children,
      useNativeAndroidPickerStyle = _a.useNativeAndroidPickerStyle;
    if (Platform.OS === "ios") {
      return this.renderIOS();
    }
    if (children || !useNativeAndroidPickerStyle) {
      return this.renderAndroidHeadless();
    }
    return this.renderAndroidNativePickerStyle();
  };
  PnmacSelect.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      color: PropTypes.string,
      displayValue: PropTypes.bool
    })).isRequired,
    value: PropTypes.any,
    placeholder: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      color: PropTypes.string
    }),
    disabled: PropTypes.bool,
    itemKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    style: PropTypes.shape({}),
    children: PropTypes.any,
    onOpen: PropTypes.func,
    useNativeAndroidPickerStyle: PropTypes.bool,
    // Custom Modal props (iOS only)
    doneText: PropTypes.string,
    onDonePress: PropTypes.func,
    onUpArrow: PropTypes.func,
    onDownArrow: PropTypes.func,
    onClose: PropTypes.func,
    // Modal props (iOS only)
    modalProps: PropTypes.shape({}),
    // TextInput props (iOS only)
    textInputProps: PropTypes.shape({}),
    // Picker props
    pickerProps: PropTypes.shape({}),
    // Touchable Done props (iOS only)
    touchableDoneProps: PropTypes.shape({}),
    // Touchable wrapper props
    touchableWrapperProps: PropTypes.shape({}),
    // Custom Icon
    Icon: PropTypes.func,
    InputAccessoryView: PropTypes.func
  };
  PnmacSelect.defaultProps = {
    value: undefined,
    placeholder: {
      label: "Select an item...",
      value: null,
      color: "#9EA0A4"
    },
    disabled: false,
    itemKey: null,
    style: {},
    children: null,
    useNativeAndroidPickerStyle: true,
    doneText: "Done",
    onDonePress: null,
    onUpArrow: null,
    onDownArrow: null,
    onOpen: null,
    onClose: null,
    modalProps: {},
    textInputProps: {},
    pickerProps: {},
    touchableDoneProps: {},
    touchableWrapperProps: {},
    Icon: null,
    InputAccessoryView: null
  };
  return PnmacSelect;
}(PureComponent);
export default PnmacSelect;
export { styles };